<template>
  <div>
    <div>
      <canvas
        @mousedown="radialClick"
        :id="`canvas-radial${this.attributes.model}`"
      ></canvas>
    </div>
  </div>
</template>

<script>
import { RadialGauge } from "canvas-gauges";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";

export default {
  mixins: [inputComponentMixin],
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    var minimum = 0;
    var step = parseInt(this.attributes.step);
    var majorTick = [];
    while (minimum < parseInt(this.config.attributes.max) + 1) {
      majorTick.push(minimum);
      minimum = minimum + step;
    }
    if (this.value) this.options.value = this.value;
    else this.value = 0;
    this.options.renderTo = this.$el;

    this.chartRadial = new RadialGauge({
      renderTo: "canvas-radial" + this.attributes.model,
      width: 200,
      height: 200,
      units: this.attributes.model,
      minValue: 0,
      startAngle: 90,
      ticksAngle: 180,
      valueBox: true,
      valueText: this.value,
      colorValueBoxBackground: "white",
      maxValue: this.attributes.max,
      majorTicks: majorTick,
      minorTicks: 4,
      strokeTicks: true,
      highlights: [
        {
          from: parseInt(this.attributes.highlightmin),
          to: parseInt(this.attributes.highlightmax),
          color: "rgba(200, 50, 50, .75)"
        }
      ],
      colorPlate: "#fff",
      borderShadowWidth: 0,
      borders: true,
      needleType: "arrow",
      needleWidth: 2,
      needleCircleSize: 7,
      needleCircleOuter: false,
      needleCircleInner: false,
      animationRule: "linear",
      animationDuration: 500
    }).draw();
  },
  watch: {
    value(val) {
      this.value = val;
      this.chartRadial.options.value = this.value;
      this.chartRadial.update();
    }
  },
  methods: {
    radialClick(event) {
      var e = event;

      var radius = this.chartRadial.options.height / 2;
      // var radius also equals to = this.chartRadial.options.width / 2;
      //-------------------------------------------------------------------------------------
      // calcul du cosinus à partir des coordonnées du clic (offsetX = coté adjacent)
      // et offsetY = coté opposé
      //-------------------------------------------------------------------------------------
      var hypotenuse = Math.sqrt(
        (radius - e.offsetY) * (radius - e.offsetY) +
          (e.offsetX - radius) * (e.offsetX - radius)
      );
      var cosinus = (e.offsetX - radius) / hypotenuse;

      var sinus = (radius - e.offsetY) / hypotenuse;
      console.log("sinus", sinus, "cosinus", cosinus);

      //--------------------------------------------------------------------------------------
      // calcul de cos-1 avec la methode math.acos mais qui donne un resultat en radians donc => transformer en d°
      //--------------------------------------------------------------------------------------

      var acosAngle = (Math.acos(cosinus) * 180) / Math.PI;
      var asinAngle = (Math.asin(sinus) * 180) / Math.PI;
      //-------------------------------------------------------------------------------------
      // report de l'angle sur la gauge ( on travaille sur le quart de cercle concerné soit une base de 90°)
      //-------------------------------------------------------------------------------------
      var halfMaxValue = this.chartRadial.options.maxValue / 2;
      //-------------------------------------------------------------------------------------
      // On vérifie si on est bien dans la zone de données
      //-------------------------------------------------------------------------------------
      if (
        (asinAngle >= this.chartRadial.options.startAngle - 90 &&
          acosAngle >= this.chartRadial.options.startAngle + 90) ||
        (acosAngle >= 90 - this.chartRadial.options.startAngle &&
          asinAngle >= 90 - this.chartRadial.options.startAngle)
      ) {
        if (asinAngle > 0) {
          this.chartRadial.value =
            ((this.chartRadial.options.ticksAngle -
              this.chartRadial.options.startAngle -
              acosAngle) *
              halfMaxValue) /
              90 +
            halfMaxValue;
        } else {
          this.chartRadial.value =
            ((acosAngle - (90 + this.chartRadial.options.startAngle)) *
              halfMaxValue) /
            90;
        }

        this.value = this.chartRadial.value;
        this.chartRadial.update();
      }
    }
  }
};
</script>
